import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../slices/languageSlice";
import { coachLoginApi, adminLoginApi, sponsorLoginApi } from "../Controller/LoginController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";
import Cookies from "js-cookie";
import {
  signInWithGoogle,
  signInWithFacebook,
} from "../../services/authService";
import Utility from "../../Utility/Utility";
import { setLoginData, setUserDetails } from "../../slices/userSlice";

const SignIn = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.language);
  const { userDetails, token } = useSelector((state) => state.user);

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("FR");
  const items = [
    { code: "fr", label: "French", flag: "assets/images/flags/fr.svg" },
    { code: "en", label: "English", flag: "assets/images/flags/uk.svg" },
  ];

  const [login, setLogin] = useState({
    email: Cookies.get("rememberMe") === "true" ? Cookies.get("email") : "",
    password: Cookies.get("rememberMe") === "true" ? Cookies.get("password") : "",
    role: Cookies.get("rememberMe") === "true" ? Cookies.get("role") : "coach",
  });
  const [loginError, setLoginError] = useState({
    email: "",
    password: "",
    role: "",
  });
  const [isRemember, setIsRemember] = useState(
    Cookies.get("rememberMe") === "true" ? true : false
  );

  useEffect(() => {
    i18n.changeLanguage(language);
    setSelected(language);
  }, [language]);

  useEffect(() => {
    if (userDetails && Object.keys(userDetails).length > 0 && token !== "") {
      navigate(`/${language || "en"}/dashboard`);
    }
  }, [userDetails, token]);

  const validateLogin = () => {
    let valid = true;
    if (login.email.trim() === "") {
      valid = false;
      setLoginError({ ...loginError, email: t("requiredField") });
    } else {
      const emailRegex =
        /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if (!emailRegex.test(login.email)) {
        valid = false;
        setLoginError({ ...loginError, email: t("invalidEmail") });
      } else {
        setLoginError({ ...loginError, email: "" });
      }
    }
    if (login.password.trim() === "") {
      valid = false;
      setLoginError({ ...loginError, password: t("requiredField") });
    } else {
      setLoginError({ ...loginError, password: "" });
    }
    if (login.role.trim() === "") {
      valid = false;
      setLoginError({ ...loginError, role: t("requiredField") });
    } else {
      setLoginError({ ...loginError, role: "" });
    }
    return valid;
  };

  const handleLogin = () => {
    let valid = validateLogin();
    if (valid) {
      let data = {
        email: login.email,
        password: login.password,
        // role: login.role,
      };
      dispatch(loaderStateTrue());
      if (login.role === "admin") {
        adminLoginApi(data)
          .then(async (response) => {
            if (response.status) {
              dispatch(
                setLoginData({
                  token: response.data.token,
                  userDetails: response.data,
                })
              );
              dispatch(setUserDetails(response.data));
              setTimeout(() => {
                dispatch(loaderStateFalse());
                navigate(`/${language}/dashboard`);
              }, 1000);
              Utility.toastNotifications(
                response.message,
                "Success",
                "success"
              );
            } else {
              dispatch(loaderStateFalse());
              Utility.toastNotifications(response.message, "Error", "error");
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 401) {
              Utility.toastNotifications(
                error.response.data.message,
                "Error",
                "error"
              );
            }
            dispatch(loaderStateFalse());
          });
      }else if (login.role === "coach") {
        coachLoginApi(data)
          .then(async (response) => {
            if (response.status) {
              dispatch(
                setLoginData({
                  token: response.data.token,
                  userDetails: response.data,
                })
              );
              dispatch(setUserDetails(response.data));
              setTimeout(() => {
                dispatch(loaderStateFalse());
                navigate(`/${language}/dashboard`);
              }, 1000);
              Utility.toastNotifications(
                response.message,
                "Success",
                "success"
              );
            } else {
              dispatch(loaderStateFalse());
              Utility.toastNotifications(response.message, "Error", "error");
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 401) {
              Utility.toastNotifications(
                error.response.data.message,
                "Error",
                "error"
              );
            }
            dispatch(loaderStateFalse());
          });
      } else {
        sponsorLoginApi(data)
          .then(async (response) => {
            if (response.status) {
              dispatch(
                setLoginData({
                  token: response.data.token,
                  userDetails: response.data,
                })
              );
              dispatch(setUserDetails(response.data));
              setTimeout(() => {
                dispatch(loaderStateFalse());
                navigate(`/${language}/dashboard`);
              }, 1000);
              Utility.toastNotifications(
                response.message,
                "Success",
                "success"
              );
            }
            // else {
            //   dispatch(loaderStateFalse());
            //   Utility.toastNotifications(response.data.message, "Error", "error");
            // }
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              // Utility.toastNotifications(
              //   error.response.data.message,
              //   "Error",
              //   "error"
              // );
            }
            dispatch(loaderStateFalse());
          });
      }
    }
  };

  const handleGoogleSignIn = async () => {
    // dispatch(loaderStateTrue());
    const result = await signInWithGoogle();
    // dispatch(loaderStateFalse());

    if (result.success) {
      console.log("Google Sign-In successful:", result.user);
      // TODO: Send user data to your backend API and handle navigation
      // Example: await coachLoginApi({ socialAuth: true, provider: 'google', user: result.user });
      alert(`Welcome ${result.user.displayName}! Google sign-in successful.`);
    } else {
      console.error("Google Sign-In failed:", result.error);
      alert(result.error);
    }
  };

  const handleFacebookSignIn = async () => {
    // dispatch(loaderStateTrue());
    const result = await signInWithFacebook();
    // dispatch(loaderStateFalse());

    if (result.success) {
      console.log("Facebook Sign-In successful:", result.user);
      // TODO: Send user data to your backend API and handle navigation
      // Example: await coachLoginApi({ socialAuth: true, provider: 'facebook', user: result.user });
      alert(`Welcome ${result.user.displayName}! Facebook sign-in successful.`);
    } else {
      console.error("Facebook Sign-In failed:", result.error);
      alert(result.error);
    }
  };

  // :: TAB
  const [activeTab, setActiveTab] = useState("coach");
  const tabs = [
    { id: "coach", label: t("Coach") },
    { id: "admin", label: t("Admin") },
    { id: "sponser", label: t("sponser") },
  ];

  return (
    <div className="lg:p-10 px-5 pt-10 pb-5">
      <div className="flex flex-wrap gap-y-10">
        <div className="lg:w-1/2 w-full">
          <div className="h-full p-5 relative">
            <div className="rounded-xl absolute inset-0 bg-[#eaede8] overflow-hidden">
              <div className="w-[22vw] h-[17vw] rounded-[50%] bg-[#0198FF] blur-[70px] absolute -top-[1vw] right-0 -rotate-[37deg] opacity-80"></div>
              <div className="w-[30vw] h-[18vw] rounded-[50%] bg-[#FB4A4A] blur-[130px] absolute -top-[2vw] left-0 rotate-[50deg]"></div>
            </div>
            <div className="relative flex flex-col gap-y-10">
              <div className="lg:-mt-16 -mt-10">
                <img
                  src={require("../../assets/images/star-players.png")}
                  alt=""
                />
              </div>
              <div className="lg:p-5 [&_h1_strong]:bg-gradient-to-r [&_h1_strong]:from-primary-950 [&_h1_strong]:to-primary-500 [&_h1_strong]:bg-clip-text [&_h1_strong]:text-transparent space-y-5">
                <h1 className="2xl:text-6xl xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-extrabold uppercase text-gray-900">
                  {t("oneTeam")}
                  <br />
                  {t("oneDream")}
                  <br />
                  <strong>{t("letsDreamTogether")}</strong>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-1/2 w-full">
          <div className="rounded-xl h-full lg:px-10 relative space-y-8 flex flex-col justify-center">
            <div className="[&_h2_strong]:text-gray-400 space-y-5">
              <h2 className="xl:text-4xl lg:text-3xl md:text-2xl text-xl font-black leading-[1.2] uppercase">
                {t("welcome")}!<br />
                <strong className="font-black">{t("exploreNow")}</strong>
              </h2>
            </div>

            <div>
              <ul className="flex gap-4">
                {items.map((item) => (
                  <li
                    key={item.code}
                    onClick={() => {
                      i18n.changeLanguage(item.code.toLowerCase());
                      dispatch(setLanguage(item.code.toLowerCase()));
                      setSelected(item.code);
                      setOpen(false);
                    }}
                    className={`flex-1 px-4 py-3 cursor-pointer rounded-lg flex items-center gap-2 border border-gray-200 hover:bg-gray-50 transition ${selected === item.code
                        ? "font-medium text-primary-400 border-primary-500 bg-white"
                        : ""
                      }`}
                  >
                    <img src={item.flag} alt={item.code} className="size-5" />
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>

            {/* <ul
              className="mb-3 nav nav-tabs flex border-b light-border 
              [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex 
              [&>*]:justify-center [&>*]:items-center [&>*]:gap-1"
            >
              {tabs.map((tab) => (
                <li
                  key={tab.id}
                  className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <button>{tab.label}</button>
                </li>
              ))}
            </ul> */}

            <div className="tab-content">
                <div className="tab-pane space-y-5">
                  <div>
                    <select name="role" id="role" className='form-select' onChange={(e) => {
                      setLogin({ ...login, role: e.target.value });
                      setLoginError({ ...loginError, role: "" });
                    }}
                      value={login.role}
                    >
                      <option value="" disabled>{t('selectRole')}</option>
                      {tabs.map((item, index) => (
                        <option key={index} value={item.id}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                  <span className="text-red-500">{loginError.role}</span>
                  <div>
                    <input
                      type="text"
                      id="email"
                      placeholder={t("email")}
                      className="form-control"
                      onChange={(e) => {
                        setLogin({ ...login, email: e.target.value });
                        setLoginError({ ...loginError, email: "" });
                      }}
                      value={login.email}
                    />
                  </div>
                  <span className="text-red-500">{loginError.email}</span>
                  <div>
                    <input
                      type="password"
                      id="password"
                      placeholder={t("password")}
                      className="form-control"
                      onChange={(e) => {
                        setLogin({ ...login, password: e.target.value });
                        setLoginError({ ...loginError, password: "" });
                      }}
                      value={login.password}
                    />
                  </div>
                  <span className="text-red-500">{loginError.password}</span>

                  <div className="flex justify-between gap-5">
                    <label className="relative inline-flex items-center gap-1.5 cursor-pointer">
                      <input
                        type="checkbox"
                        className="input-checkbox"
                        checked={isRemember}
                        onChange={(e) => {
                          setIsRemember(e.target.checked);
                          Cookies.set("rememberMe", e.target.checked);
                          Cookies.set("email", login.email);
                          Cookies.set("password", login.password);
                        }}
                      />
                      <span className="font-secondary font-medium">
                        {t("rememberMe")}
                      </span>
                    </label>
                    <Link
                      to="../forgot_password"
                      className="font-secondary font-medium text-gray-400 hover:underline"
                    >
                      {t("forgotPassword")}
                    </Link>
                  </div>

                  <button
                    className="w-full btn btn-primary"
                    onClick={handleLogin}
                  >
                    {t("signIn")}
                  </button>

                  <div className="font-secondary 2xl:text-xl text-lg font-bold text-gray-800">
                    {t("orSignInWith")}
                  </div>

                  <div className="space-y-3">
                    <button
                      className="w-full btn !border !border-gray-200 !inline-flex items-center gap-2"
                      onClick={handleGoogleSignIn}
                    >
                      <img
                        src="assets/images/icons/google.svg"
                        alt=""
                        width="24"
                      />
                      {t("signInWithGoogle")}
                    </button>
                    <button
                      className="w-full btn !border !border-gray-200 !inline-flex items-center gap-2"
                      onClick={handleFacebookSignIn}
                    >
                      <img
                        src="assets/images/icons/facebook-fill.svg"
                        alt="Facebook"
                        width="24"
                        className="fb-color"
                      />{" "}
                      {t("signInWithFacebook")}
                    </button>
                  </div>

                  <p className="mt-2 font-secondary">
                    {t("dontHaveAccount")}{" "}
                    <Link
                      to="../sign-up"
                      className="text-primary-500 font-medium hover:underline"
                    >
                      {t("requestAccess")}
                    </Link>
                  </p>
                </div>

              {/* {activeTab === "admin" && (
                <div className="tab-pane space-y-5">
                  <div>
                    <input
                      type="text"
                      id="email"
                      placeholder={t("email")}
                      className="form-control"
                      onChange={(e) => {
                        setLogin({ ...login, email: e.target.value });
                        setLoginError({ ...loginError, email: "" });
                      }}
                      value={login.email}
                    />
                  </div>
                  <span className="text-red-500">{loginError.email}</span>
                  <div>
                    <input
                      type="password"
                      id="password"
                      placeholder={t("password")}
                      className="form-control"
                      onChange={(e) => {
                        setLogin({ ...login, password: e.target.value });
                        setLoginError({ ...loginError, password: "" });
                      }}
                      value={login.password}
                    />
                  </div>
                  <span className="text-red-500">{loginError.password}</span>
                  <div className="flex justify-between gap-5">
                    <label className="relative inline-flex items-center gap-1.5 cursor-pointer">
                      <input
                        type="checkbox"
                        className="input-checkbox"
                        checked={isRemember}
                        onChange={(e) => {
                          setIsRemember(e.target.checked);
                          Cookies.set("rememberMe", e.target.checked);
                          Cookies.set("email", login.email);
                          Cookies.set("password", login.password);
                        }}
                      />
                      <span className="font-secondary font-medium">
                        {t("rememberMe")}
                      </span>
                    </label>
                  </div>
                  <button
                    className="w-full btn btn-primary"
                    onClick={handleLogin}
                  >
                    {t("signIn")}
                  </button>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
